import { LatLngTuple } from "leaflet";

export const POSITION = [49.1800242, 32.2672279] as LatLngTuple;
export const ZOOM = 7;
